// extracted by mini-css-extract-plugin
export var backgroundStyle = "section-module--backgroundStyle--7Khhj";
export var filter = "section-module--filter--U99et";